/** Local preferences + save slot (client-only until backend exists). */

export const PREFS_CHANGED = 'velvetRoom:prefs';

/** Сброс локального слота игры — слушает `GameSessionFlow`, возврат на экран Player ID. */
export const GAME_SESSION_RESET = 'velvetRoom:gameSessionReset';

/** Чит-панель: `detail.amount` — сколько токенов добавить (см. `GameSessionFlow`). */
export const GAME_CHEAT_ADD_TOKENS = 'velvetRoom:cheatAddTokens';

/** Write JSON (or any string) here from the game loop; `clearStoredProgress` removes it. */
export const GAME_PROGRESS_STORAGE_KEY = 'velvetRoom.progress';

const LS = {
  soundPct: 'velvetRoom.soundPct',
  musicPct: 'velvetRoom.musicPct',
  nickname: 'velvetRoom.nickname',
  playerId: 'velvetRoom.playerId',
  progress: GAME_PROGRESS_STORAGE_KEY
};

function emit() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(PREFS_CHANGED));
  }
}

function clampPct(n) {
  if (!Number.isFinite(n)) return 100;
  return Math.min(100, Math.max(0, Math.round(n)));
}

function readPct(key, fallback = 100) {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null) return fallback;
    return clampPct(Number(raw));
  } catch {
    return fallback;
  }
}

function writePct(key, v) {
  localStorage.setItem(key, String(clampPct(v)));
  emit();
}

export function getSoundVolumePct() {
  return readPct(LS.soundPct, 100);
}

export function setSoundVolumePct(v) {
  writePct(LS.soundPct, v);
}

export function getMusicVolumePct() {
  return readPct(LS.musicPct, 100);
}

export function setMusicVolumePct(v) {
  writePct(LS.musicPct, v);
}

export function soundVolume01() {
  return getSoundVolumePct() / 100;
}

export function musicVolume01() {
  return getMusicVolumePct() / 100;
}

const MAX_NICK = 24;

export function getStoredNickname(fallback = 'Alex') {
  try {
    const s = localStorage.getItem(LS.nickname);
    if (!s || !s.trim()) return fallback;
    return s.trim().slice(0, MAX_NICK);
  } catch {
    return fallback;
  }
}

export function setStoredNickname(name) {
  const t = String(name).trim().slice(0, MAX_NICK);
  localStorage.setItem(LS.nickname, t);
  emit();
}

const MAX_PLAYER_ID = 64;

export function getStoredPlayerId() {
  try {
    const s = localStorage.getItem(LS.playerId);
    if (!s || !s.trim()) return '';
    return s.trim().slice(0, MAX_PLAYER_ID);
  } catch {
    return '';
  }
}

export function setStoredPlayerId(id) {
  const t = String(id).trim().slice(0, MAX_PLAYER_ID);
  localStorage.setItem(LS.playerId, t);
  emit();
}

export function clearStoredPlayerId() {
  try {
    localStorage.removeItem(LS.playerId);
  } catch {
    /* ignore */
  }
  emit();
}

/** Локальный слот: прогресс, playerId, ник; затем событие для сброса UI сессии (старт игры). */
export function clearStoredProgress() {
  try {
    localStorage.removeItem(LS.progress);
    localStorage.removeItem(LS.playerId);
    localStorage.removeItem(LS.nickname);
  } catch {
    /* ignore */
  }
  emit();
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(GAME_SESSION_RESET));
  }
}

export function hasStoredProgress() {
  try {
    return localStorage.getItem(LS.progress) != null;
  } catch {
    return false;
  }
}
